import {Box, Divider, List, Typography} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import {uniqBy} from 'lodash'
import React, {useMemo} from 'react'
import {Redirect, useParams} from 'react-router-dom'

import {Category, TariffsPageParams, UrlsType} from '../../types'
import {NavListItem} from '../nav-list-item'

type Props = {
  urls: UrlsType
  tariffList: Category[]
}

const TariffsColumn: React.FC<Props> = ({urls, tariffList}) => {
  const t = useI18n()
  const {category, zone} = useParams<TariffsPageParams>()

  const uniqueTariffItems = useMemo(() => {
    return uniqBy(tariffList, 'category_name')
  }, [tariffList])

  const redirectToTariff = useMemo(() => {
    return tariffList.find(tariffItem => tariffItem.category_name === category)
      ? undefined
      : tariffList[0]?.category_name
  }, [tariffList, category])

  if (zone && redirectToTariff) {
    return (
      <Redirect
        to={urls.zone.categoryUrl({
          zone,
          category: redirectToTariff,
        })}
      />
    )
  }

  return (
    <>
      <Typography
        Component="h3"
        pb="m"
        pt="m"
        style={{
          paddingInline: 12,
        }}
        variant="body1"
      >
        {t('tariffs.column_title.tariffs')}
      </Typography>
      <Divider />
      {zone && (
        <Box data-e2e="tariffs" pb="m" pt="l">
          {!tariffList.length && (
            <Typography variant="body2">{t('tariffs.column.no_tariffs', 'Нет тарифов')}</Typography>
          )}
          <List
            getId={item => item?.category_name}
            items={uniqueTariffItems}
            renderItem={(item, {isSelected}) => (
              <NavListItem
                isSelected={isSelected}
                title={item.category_name_translate}
                url={urls.zone.categoryUrl({zone, category: item.category_name})}
              />
            )}
            selectedItemId={category}
          />
        </Box>
      )}
    </>
  )
}

export default TariffsColumn
